import React, { useEffect, useState } from 'react';
import { PeriodoContenidoEntity } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorTiposContenido = (props:any) =>{

  let {data, onChange, disabled} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
    if(data.length > 0 && !disabled) change(data[0].idTipoContenido)
    else if (disabled) change(undefined)
  },[data, disabled])
  
  const change = (value:any) =>{
    onChange(value)
  }

  const getOptions = () =>{
    return data.map((p: PeriodoContenidoEntity)=> { return { value: p.idTipoContenido, inputDisplay: p.tipoContenido } })
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectTipoContenido"/>
  )
}
export default SelectorTiposContenido